var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_47024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_312_47024)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43201 11.873C8.93026 10.3488 11.263 9.34403 12.4301 8.85856C15.7627 7.47245 16.4551 7.23167 16.9065 7.22372C17.0058 7.22197 17.2277 7.24657 17.3715 7.36323C17.4929 7.46174 17.5263 7.59481 17.5423 7.68821C17.5583 7.7816 17.5782 7.99436 17.5623 8.16061C17.3817 10.0581 16.6003 14.6628 16.2028 16.788C16.0346 17.6872 15.7034 17.9888 15.3827 18.0183C14.6858 18.0824 14.1567 17.5577 13.4817 17.1153C12.4256 16.423 11.8289 15.992 10.8037 15.3164C9.61896 14.5357 10.387 14.1066 11.0622 13.4053C11.2389 13.2217 14.3093 10.429 14.3687 10.1756C14.3762 10.144 14.3831 10.0258 14.3129 9.96348C14.2427 9.90111 14.1392 9.92244 14.0644 9.9394C13.9585 9.96344 12.2713 11.0786 9.00276 13.285C8.52385 13.6138 8.09007 13.7741 7.70141 13.7657C7.27295 13.7564 6.44876 13.5234 5.83606 13.3242C5.08456 13.08 4.48728 12.9508 4.53929 12.5359C4.56638 12.3198 4.86395 12.0989 5.43201 11.873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_47024",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 23.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_47024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.beb6fcf1868106cb6369f1a010fa90dd.svg";
export { ForwardRef as ReactComponent };